import React from "react";
import { ResumenPorHabitacion } from "../EstadisticasHotel";

interface Props {
    habitaciones: ResumenPorHabitacion[];
    isOpen: boolean;
    onClose: () => void;
}

export const HabitacionesRatiosList: React.FC<Props> = ({
    habitaciones,
    isOpen,
    onClose,
}) => {
    if (!isOpen) return null;

    const conRatios = habitaciones.filter((h) => {
        const { lead_alquiler, lead_negocio, negocio_alquiler } = h.ratios;
        return (
            parseFloat(lead_alquiler) > 0 ||
            parseFloat(lead_negocio) > 0 ||
            parseFloat(negocio_alquiler) > 0
        );
    });

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-11/12 p-6 bg-white rounded-lg shadow-lg md:w-8/12 lg:w-6/12">
                <button
                    onClick={onClose}
                    className="absolute text-gray-600 top-3 right-3 hover:text-gray-800"
                    aria-label="Cerrar modal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="mb-4 text-xl font-semibold text-center">
                    Ratios por Habitación
                </h2>

                {conRatios.length === 0 ? (
                    <p className="py-4 text-center text-gray-600">
                        No hay ratios para mostrar este mes.
                    </p>
                ) : (
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {conRatios.map((h) => (
                            <div
                                key={h.id}
                                className="flex flex-col items-start p-4 border rounded">
                                <img
                                    src={`${process.env.REACT_APP_PROXY}/hotel_habitaciones/getImage/${h.habitacion.banner}`}
                                    alt={h.habitacion.nombre}
                                    className="object-cover w-full h-32 mb-3 rounded"
                                />
                                <p className="mb-2 font-medium">
                                    {h.habitacion.nombre}
                                </p>
                                <ul className="space-y-1 text-sm text-gray-700">
                                    <li>
                                        <strong>Lead-Alquiler:</strong>{" "}
                                        {h.ratios.lead_alquiler}%
                                    </li>
                                    <li>
                                        <strong>Lead-Negocio:</strong>{" "}
                                        {h.ratios.lead_negocio}%
                                    </li>
                                    <li>
                                        <strong>Negocio-Alquiler:</strong>{" "}
                                        {h.ratios.negocio_alquiler}%
                                    </li>
                                </ul>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
